import React, { useState } from "react";

export default function UsePasswordToggle() {
  const [visible, setVisibility] = useState(false);
  const Icon = (
    <span>
      <p onClick={() => setVisibility((visiblity) => !visiblity)}>
        {visible ? (
          <i className="ri-eye-line"></i>
        ) : (
          <i className="ri-eye-close-line"></i>
        )}
      </p>
    </span>
  );
  const InputType = visible ? "text" : "password";
  return [InputType, Icon];
}
